export default __webpack_public_path__ + "static/media/Animation05.2b3832df.gif";